import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Input, Checkbox, Radio } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';

class State {
    setName1: string; setName2: string; setName3: string; setName4: string; setName5: string;
    setName6: string; setName7: string; setName8: string; setName9: string; setName10: string;
    setScan1: boolean; setScan2: boolean; setScan3: boolean; setScan4: boolean; setScan5: boolean;
    setScan6: boolean; setScan7: boolean; setScan8: boolean; setScan9: boolean; setScan10: boolean;
    scanAutoStartReset: boolean; scanIvl: string; scanMode: string; scanStreamPerGroup: number;
    streamGroupDisabled: boolean; schedulerAutoStartReset: boolean;

}

interface Props {

}

export default class ScanScheduleConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            setName1: '', setName2: '', setName3: '', setName4: '', setName5: '',
            setName6: '', setName7: '', setName8: '', setName9: '', setName10: '',
            setScan1: false, setScan2: false, setScan3: false, setScan4: false, setScan5: false,
            setScan6: false, setScan7: false, setScan8: false, setScan9: false, setScan10: false,
            scanAutoStartReset: false, scanIvl: '', scanMode: '', scanStreamPerGroup: 4,
            streamGroupDisabled: false, schedulerAutoStartReset: false

        });
        this.fetchData();
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                { 'name': 'setName', 'input': 1}, { 'name': 'setName', 'input': 2}, { 'name': 'setName', 'input': 3},
                { 'name': 'setName', 'input': 4}, { 'name': 'setName', 'input': 5}, { 'name': 'setName', 'input': 6},
                { 'name': 'setName', 'input': 7}, { 'name': 'setName', 'input': 8}, { 'name': 'setName', 'input': 9},
                { 'name': 'setName', 'input': 10},  { 'name': 'setScanEnable', 'input': 1}, { 'name': 'setScanEnable', 'input': 2},
                { 'name': 'setScanEnable', 'input': 3}, { 'name': 'setScanEnable', 'input': 4}, { 'name': 'setScanEnable', 'input': 5},
                { 'name': 'setScanEnable', 'input': 6}, { 'name': 'setScanEnable', 'input': 7}, { 'name': 'setScanEnable', 'input': 8},
                { 'name': 'setScanEnable', 'input': 9}, { 'name': 'setScanEnable', 'input': 10}, 'scanAutoStartReset',
                'scanIvl', 'scanMode', 'scanStreamPerGroup', 'schedulerAutoStartReset'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        setName1: responseObject[0].value, setName2: responseObject[1].value, setName3: responseObject[2].value,
                        setName4: responseObject[3].value, setName5: responseObject[4].value, setName6: responseObject[5].value,
                        setName7: responseObject[6].value, setName8: responseObject[7].value, setName9: responseObject[8].value,
                        setName10: responseObject[9].value, setScan1: responseObject[10].value, setScan2: responseObject[11].value,
                        setScan3: responseObject[12].value, setScan4: responseObject[13].value, setScan5: responseObject[14].value,
                        setScan6: responseObject[15].value, setScan7: responseObject[16].value, setScan8: responseObject[17].value,
                        setScan9: responseObject[18].value, setScan10: responseObject[19].value, scanAutoStartReset: responseObject[20].value,
                        scanIvl: responseObject[21].value, scanMode: responseObject[22].value, scanStreamPerGroup: responseObject[23].value,
                        schedulerAutoStartReset: responseObject[24].value
                    },
                                   () => _this.isGroupDisabled(_this.state.scanMode));
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });
    }

    isGroupDisabled(props: string) {
        if (props === 'capacity' || props === 'by') {
            this.setState({
                streamGroupDisabled: true
            });
        }
    }
    updateConfig(e: any, data: any) {
        //    let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: [{ 'name': 'setName', 'input': 1, value: this.state.setName1}, { 'name': 'setName', 'input': 2, value: this.state.setName2},
                { 'name': 'setName', 'input': 3, value: this.state.setName3}, { 'name': 'setName', 'input': 4, value: this.state.setName4},
                { 'name': 'setName', 'input': 5, value: this.state.setName5}, { 'name': 'setName', 'input': 6, value: this.state.setName6},
                { 'name': 'setName', 'input': 7, value: this.state.setName7}, { 'name': 'setName', 'input': 8, value: this.state.setName8},
                { 'name': 'setName', 'input': 9, value: this.state.setName9}, { 'name': 'setName', 'input': 10, value: this.state.setName10},
                { 'name': 'setScanEnable', 'input': 1, value: this.state.setScan1}, { 'name': 'setScanEnable', 'input': 2, value: this.state.setScan2},
                { 'name': 'setScanEnable', 'input': 3, value: this.state.setScan3}, { 'name': 'setScanEnable', 'input': 4, value: this.state.setScan4},
                { 'name': 'setScanEnable', 'input': 5, value: this.state.setScan5}, { 'name': 'setScanEnable', 'input': 6, value: this.state.setScan6},
                { 'name': 'setScanEnable', 'input': 7, value: this.state.setScan7}, { 'name': 'setScanEnable', 'input': 8, value: this.state.setScan8},
                { 'name': 'setScanEnable', 'input': 9, value: this.state.setScan9}, { 'name': 'setScanEnable', 'input': 10, value: this.state.setScan10},
                {
                    'name': 'scanAutoStartReset',
                    'value': this.state.scanAutoStartReset
                }, {
                    'name': 'scanIvl',
                    'value': this.state.scanIvl
                }, {
                    'name': 'scanMode',
                    'value': this.state.scanMode
                }, {
                    'name': 'scanStreamPerGroup',
                    'value': this.state.scanStreamPerGroup
                }, {
                    'name': 'schedulerAutoStartReset',
                    'value': this.state.schedulerAutoStartReset
                }
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('Scan/Schedule configuration applied');
                } else {
                    Toast.error('Failed to update Scan/Schedule configuration');
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Failed to update Scan/Schedule configuration');
            });
    }
    render() {

        return (
            <React.Fragment>
                <div className="assetAliasFilters">
                    <Label className="system-config-pageHeader">
                        Scan/Schedule
                    </Label>
                    <Button
                        floated="right"
                        className="rightButton"
                        content="Apply"
                        title="Update Config"
                        onClick={(e, data) => this.updateConfig(e, data)}
                    />
                </div>
                <div className="vertical-flex-main">
                <Segment.Group className="system-config-segment setDefinitions">
                    <Segment className="segment-header">Set Definitions</Segment>
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    1.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName1}
                                    onChange={(e: any, data: any) => this.setState({setName1: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan1}
                                    onChange={(e: any, data: any) => this.setState({setScan1: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    2.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName2}
                                    onChange={(e: any, data: any) => this.setState({setName2: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan2}
                                    onChange={(e: any, data: any) => this.setState({setScan2: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    3.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName3}
                                    onChange={(e: any, data: any) => this.setState({setName3: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan3}
                                    onChange={(e: any, data: any) => this.setState({setScan3: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    4.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName4}
                                    onChange={(e: any, data: any) => this.setState({setName4: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan4}
                                    onChange={(e: any, data: any) => this.setState({setScan4: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    5.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName5}
                                    onChange={(e: any, data: any) => this.setState({setName5: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan5}
                                    onChange={(e: any, data: any) => this.setState({setScan5: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    6.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName6}
                                    onChange={(e: any, data: any) => this.setState({setName6: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan6}
                                    onChange={(e: any, data: any) => this.setState({setScan6: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    7.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName7}
                                    onChange={(e: any, data: any) => this.setState({setName7: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan7}
                                    onChange={(e: any, data: any) => this.setState({setScan7: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    8.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName8}
                                    onChange={(e: any, data: any) => this.setState({setName8: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan8}
                                    onChange={(e: any, data: any) => this.setState({setScan8: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    9.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName9}
                                    onChange={(e: any, data: any) => this.setState({setName9: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan9}
                                    onChange={(e: any, data: any) => this.setState({setScan9: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    10.
                                </Label>
                                <Input
                                    maxLength={31}
                                    value={this.state.setName10}
                                    onChange={(e: any, data: any) => this.setState({setName10: data.value})}
                                />
                                <Checkbox
                                    checked={this.state.setScan10}
                                    onChange={(e: any, data: any) => this.setState({setScan10: data.checked})}
                                />
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>
                <Segment.Group className="system-config-segment">
                    <Segment className="segment-header">Auto Scan</Segment>
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    Start Auto Scan After Reset
                                </Label>
                                <Checkbox
                                    className="config-checkbox"
                                    checked={this.state.scanAutoStartReset}
                                    onChange={(e: any, data: any) => this.setState({scanAutoStartReset: data.checked})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    Scan Interval (minutes)
                                </Label>
                                <Input
                                    maxLength={9}
                                    value={this.state.scanIvl}
                                    onChange={(e: any, data: any) => this.setState({scanIvl: data.value})}
                                />
                            </Form.Group>
                            <Form.Field>
                                <Label className="right-align-label">
                                    Scan Mode:
                                </Label>
                            </Form.Field>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    Capacity
                                </Label>
                                <Radio
                                    name="radioGroup"
                                    value="capacity"
                                    checked={this.state.scanMode === 'capacity'}
                                    onChange={(e: any, data: any) => this.setState({scanMode: data.value, streamGroupDisabled: true})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    By Set
                                </Label>
                                <Radio
                                    name="radioGroup"
                                    value="by"
                                    checked={this.state.scanMode === 'by'}
                                    onChange={(e: any, data: any) => this.setState({scanMode: data.value, streamGroupDisabled: true})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    Across Sets
                                </Label>
                                <Radio
                                    name="radioGroup"
                                    value="across"
                                    checked={this.state.scanMode === 'across'}
                                    onChange={(e: any, data: any) => this.setState({scanMode: data.value, streamGroupDisabled: false})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    Streams Per Group
                                </Label>
                                <Input
                                    value={this.state.scanStreamPerGroup}
                                    disabled={this.state.streamGroupDisabled}
                                    type="number"
                                    min="1"
                                    max="100"
                                    onChange={(e: any, data: any) => this.setState({scanStreamPerGroup: data.value})}
                                />
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>
                <Segment.Group className="system-config-segment">
                    <Segment className="segment-header">Schedule</Segment>

                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Label className="right-align-label">
                                    Start Schedule After Reset
                                </Label>
                                <Checkbox
                                    className="config-checkbox"
                                    checked={this.state.schedulerAutoStartReset}
                                    onChange={(e: any, data: any) => this.setState({schedulerAutoStartReset: data.checked})}
                                />
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>
                </div>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/scanScheduleConfig.tsx